/* ============================================================================
 * เนื้อหานโยบายความเป็นส่วนตัว (ไทย / อังกฤษ)
 *
 * แยกออกมาจากหน้า policy_privacy.js เพราะเป็นข้อความยาวที่แก้บ่อยกว่าโครงหน้า
 * และไม่เหมาะจะยัดเป็น key ใน language/th.json (จะกลายเป็น key ย่อยนับร้อย)
 *
 * หัวข้อ "การเข้าสู่ระบบด้วยบัญชี LINE" (key: line) เป็นข้อบังคับ ห้ามลบ —
 * LINE Developers Console ใช้หน้านี้ประกอบการอนุมัติ Email address permission
 * ถ้าไม่มีข้อความแจ้งว่าเก็บอีเมลไปทำอะไร คำขอจะไม่ผ่าน
 *
 * โครงสร้าง block ที่ renderer รองรับ
 *   { type: "p",  text: "..." }                     ย่อหน้า
 *   { type: "ul", items: ["...", { label, text }] } รายการ (ใส่ label เพื่อทำหัวข้อตัวหนา)
 *   { type: "note", text: "..." }                   กล่องเน้นข้อความ
 * ========================================================================== */

/* ---------------------------------------------------------------- ข้อมูลบริษัท
 * แก้ที่เดียวจุดนี้ แล้วมีผลทั้งฉบับไทยและอังกฤษ
 * TODO: ใส่ที่อยู่จดทะเบียน เบอร์โทร และโดเมนจริงก่อนขึ้น production */
export const POLICY_COMPANY = {
    name_th: "บริษัท มูเนร่า เรียลเอสเตท จำกัด",
    name_en: "SafeSpace Life Living Co., Ltd.",
    brand: "SafeSpace Life Living",
    website: "https://safespacelifeliving.com",
    email: "privacy@safespacelifeliving.com",
    phone: "02-000-0000",
    address_th: "กรุงเทพมหานคร ประเทศไทย",
    address_en: "Bangkok, Thailand",
};

/* วันที่ปรับปรุงล่าสุด — อัปเดตทุกครั้งที่แก้เนื้อหาด้านล่าง */
export const POLICY_UPDATED = { TH: "3 สิงหาคม 2569", EN: "3 August 2026" };

/* ------------------------------------------------------------ เนื้อหาฉบับไทย */
const TH = {
  title: "นโยบายความเป็นส่วนตัว",
  subtitle: `นโยบายฉบับนี้อธิบายว่า ${POLICY_COMPANY.name_th} เก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของคุณอย่างไร เมื่อคุณใช้งานระบบบริหารจัดการอสังหาริมทรัพย์ ${POLICY_COMPANY.brand}`,
  lead: `${POLICY_COMPANY.name_th} ("บริษัท" "เรา") ให้ความสำคัญกับข้อมูลส่วนบุคคลของผู้ใช้งาน และดำเนินการตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA) นโยบายฉบับนี้ใช้กับระบบ ${POLICY_COMPANY.brand} ทั้งส่วนสำหรับพนักงานและนายหน้า และส่วนเว็บไซต์สาธารณะที่เปิดให้ผู้สนใจเข้าชมประกาศทรัพย์`,
  sections: [
    {
      key: "data_collect",
      title: "1. ข้อมูลที่เราเก็บรวบรวม",
      blocks: [
        { type: "p", text: "เราเก็บรวบรวมข้อมูลเท่าที่จำเป็นต่อการให้บริการ ดังนี้" },
        {
          type: "ul",
          items: [
            { label: "ข้อมูลบัญชีผู้ใช้", text: "ชื่อ-นามสกุล ชื่อเล่น อีเมล เบอร์โทรศัพท์ ตำแหน่ง ทีมที่สังกัด และรูปโปรไฟล์" },
            { label: "ข้อมูลจากบัญชี LINE", text: "กรณีที่คุณเลือกเข้าสู่ระบบด้วย LINE (ดูรายละเอียดในข้อ 2)" },
            { label: "ข้อมูลการใช้งาน", text: "หมายเลข IP ชนิดและเวอร์ชันของเบราว์เซอร์ หน้าที่เข้าชม วันเวลาที่เข้าใช้ และบันทึกการเข้าสู่ระบบ" },
            { label: "ข้อมูลที่คุณกรอกเข้าระบบ", text: "ข้อมูลทรัพย์ ข้อมูลลูกค้าและเจ้าของทรัพย์ นัดหมาย และเอกสารประกอบที่อัปโหลด" },
            { label: "คุกกี้", text: "ใช้เก็บสถานะการเข้าสู่ระบบและการตั้งค่าส่วนตัว เช่น ภาษาที่เลือก (ดูข้อ 5)" },
          ],
        },
        {
          type: "p",
          text: "เมื่อคุณบันทึกข้อมูลของลูกค้าหรือเจ้าของทรัพย์เข้าสู่ระบบ คุณมีหน้าที่ตรวจสอบว่าได้รับความยินยอมหรือมีฐานทางกฎหมายรองรับการเก็บข้อมูลนั้นแล้ว",
        },
      ],
    },
    {
      key: "line",
      title: "2. การเข้าสู่ระบบด้วยบัญชี LINE",
      highlight: true,
      blocks: [
        {
          type: "p",
          text: "ระบบเปิดให้เข้าสู่ระบบด้วยบัญชี LINE ผ่านบริการ LINE Login เมื่อคุณกดปุ่ม “เข้าสู่ระบบด้วย LINE” และกดยินยอมบนหน้าจอของ LINE เราจะได้รับข้อมูลต่อไปนี้จาก LINE Corporation",
        },
        {
          type: "ul",
          items: [
            { label: "รหัสผู้ใช้ LINE (User ID)", text: "ใช้เป็นตัวระบุตัวตนหลักในการผูกบัญชี LINE ของคุณเข้ากับบัญชีผู้ใช้ในระบบ" },
            { label: "อีเมล", text: "ใช้จับคู่บัญชี LINE ของคุณกับบัญชีผู้ใช้ที่มีอยู่แล้วในระบบ เพื่อยืนยันว่าคุณเป็นพนักงานหรือนายหน้าที่ได้รับสิทธิ์เข้าใช้งาน และใช้ติดต่อเรื่องบัญชีของคุณ" },
            { label: "ชื่อที่แสดง (Display name)", text: "ใช้แสดงเป็นชื่อผู้ใช้ในระบบเมื่อยังไม่ได้ตั้งชื่อไว้" },
            { label: "รูปโปรไฟล์", text: "ใช้แสดงเป็นรูปประจำตัวในระบบ" },
          ],
        },
        {
          type: "note",
          text: "เราใช้อีเมลที่ได้รับจาก LINE เพื่อยืนยันตัวตนและผูกบัญชีเท่านั้น เราไม่นำอีเมลไปใช้ส่งโฆษณา ไม่ขาย และไม่เปิดเผยให้บุคคลภายนอกเพื่อวัตถุประสงค์ทางการตลาด",
        },
        {
          type: "p",
          text: "เราขอสิทธิ์เข้าถึงเฉพาะข้อมูลข้างต้น (scope: openid, profile, email) เท่านั้น เราไม่สามารถเข้าถึงรายชื่อเพื่อน กลุ่ม ห้องแชท หรือข้อความใด ๆ ในบัญชี LINE ของคุณ และไม่สามารถส่งข้อความในนามของคุณได้",
        },
        {
          type: "p",
          text: "หากคุณไม่ประสงค์จะให้อีเมล คุณสามารถไม่กดยินยอมในหน้าจอของ LINE ได้ ในกรณีนั้นคุณยังเข้าสู่ระบบด้วยอีเมลและรหัสผ่านได้ตามปกติ",
        },
        {
          type: "p",
          text: "คุณสามารถยกเลิกการผูกบัญชี LINE ได้ตลอดเวลาที่หน้าตั้งค่าบัญชีในระบบ เมื่อยกเลิกแล้ว เราจะลบรหัสผู้ใช้ LINE ชื่อที่แสดง และรูปโปรไฟล์ที่ได้รับจาก LINE ออกจากบัญชีของคุณ และคุณจะเข้าสู่ระบบด้วย LINE ไม่ได้จนกว่าจะผูกใหม่",
        },
        {
          type: "p",
          text: "การใช้งาน LINE Login อยู่ภายใต้นโยบายความเป็นส่วนตัวของ LINE Corporation ด้วยอีกชั้นหนึ่ง ซึ่งอยู่นอกเหนือการควบคุมของเรา",
        },
      ],
    },
    {
      key: "purpose",
      title: "3. วัตถุประสงค์ในการใช้ข้อมูล",
      blocks: [
        { type: "p", text: "เราใช้ข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์ดังต่อไปนี้" },
        {
          type: "ul",
          items: [
            "ยืนยันตัวตน จัดการสิทธิ์การเข้าถึง และรักษาความปลอดภัยของบัญชี",
            "ให้บริการระบบบริหารจัดการทรัพย์ ลูกค้า นัดหมาย และรายงานตามหน้าที่งานของคุณ",
            "ติดต่อคุณเกี่ยวกับบัญชี การแจ้งเตือนในระบบ และการเปลี่ยนแปลงที่สำคัญของบริการ",
            "ตรวจสอบ ป้องกัน และสอบสวนการใช้งานที่ผิดปกติหรือผิดกฎหมาย",
            "วิเคราะห์การใช้งานในภาพรวมเพื่อปรับปรุงระบบให้ใช้งานได้ดีขึ้น",
            "ปฏิบัติตามกฎหมายและคำสั่งของหน่วยงานที่มีอำนาจ",
          ],
        },
        {
          type: "p",
          text: "เราไม่ใช้ข้อมูลส่วนบุคคลของคุณเพื่อวัตถุประสงค์อื่นนอกเหนือจากที่ระบุไว้ เว้นแต่ได้รับความยินยอมจากคุณเพิ่มเติม หรือมีกฎหมายกำหนดไว้",
        },
      ],
    },
    {
      key: "legal_basis",
      title: "4. ฐานทางกฎหมายในการประมวลผล",
      blocks: [
        {
          type: "ul",
          items: [
            { label: "การปฏิบัติตามสัญญา", text: "เพื่อให้บริการระบบตามข้อตกลงการใช้งานระหว่างคุณหรือหน่วยงานต้นสังกัดกับเรา" },
            { label: "ประโยชน์โดยชอบด้วยกฎหมาย", text: "เพื่อรักษาความปลอดภัยของระบบ ป้องกันการทุจริต และพัฒนาบริการ" },
            { label: "ความยินยอม", text: "สำหรับข้อมูลที่คุณเลือกให้เอง เช่น อีเมลและโปรไฟล์จากบัญชี LINE" },
            { label: "การปฏิบัติตามกฎหมาย", text: "เมื่อมีหน้าที่ต้องเก็บรักษาหรือเปิดเผยข้อมูลตามที่กฎหมายกำหนด" },
          ],
        },
      ],
    },
    {
      key: "cookies",
      title: "5. คุกกี้และเทคโนโลยีที่คล้ายกัน",
      blocks: [
        {
          type: "ul",
          items: [
            { label: "คุกกี้ที่จำเป็น", text: "ใช้เก็บสถานะการเข้าสู่ระบบ (token) เพื่อให้คุณไม่ต้องเข้าสู่ระบบใหม่ทุกครั้ง หากปิดการใช้งานจะไม่สามารถใช้ระบบได้" },
            { label: "คุกกี้เพื่อการทำงาน", text: "ใช้จดจำการตั้งค่าของคุณ เช่น ภาษาที่เลือก และอีเมลที่ให้จดจำไว้ในหน้าเข้าสู่ระบบ" },
          ],
        },
        {
          type: "p",
          text: "คุณสามารถตั้งค่าเบราว์เซอร์ให้ปฏิเสธคุกกี้ได้ แต่บางส่วนของระบบอาจทำงานไม่สมบูรณ์",
        },
      ],
    },
    {
      key: "share",
      title: "6. การเปิดเผยข้อมูลแก่บุคคลภายนอก",
      blocks: [
        { type: "p", text: "เราไม่ขายข้อมูลส่วนบุคคลของคุณ และเปิดเผยข้อมูลเฉพาะกรณีต่อไปนี้" },
        {
          type: "ul",
          items: [
            { label: "ผู้ให้บริการที่เราใช้งาน", text: "เช่น ผู้ให้บริการเซิร์ฟเวอร์ ระบบจัดเก็บไฟล์ และบริการยืนยันตัวตน โดยผูกพันตามสัญญาให้รักษาความลับและใช้ข้อมูลเท่าที่จำเป็น" },
            { label: "ภายในองค์กร", text: "ผู้ใช้งานคนอื่นในบริษัทเห็นข้อมูลได้เท่าที่สิทธิ์ของบทบาท (role) กำหนดไว้เท่านั้น" },
            { label: "ตามกฎหมาย", text: "เมื่อได้รับคำสั่งจากศาลหรือหน่วยงานรัฐที่มีอำนาจ หรือเพื่อปกป้องสิทธิและความปลอดภัยของบริษัทและผู้ใช้งาน" },
            { label: "การโอนกิจการ", text: "กรณีควบรวมหรือโอนกิจการ เราจะแจ้งให้คุณทราบก่อนข้อมูลถูกโอนไปอยู่ภายใต้นโยบายอื่น" },
          ],
        },
      ],
    },
    {
      key: "retention",
      title: "7. ระยะเวลาการเก็บรักษาข้อมูล",
      blocks: [
        {
          type: "p",
          text: "เราเก็บข้อมูลส่วนบุคคลไว้เท่าที่จำเป็นตามวัตถุประสงค์ในนโยบายนี้ โดยจะเก็บตลอดระยะเวลาที่บัญชีของคุณยังใช้งานอยู่ และเก็บต่อหลังปิดบัญชีเท่าที่จำเป็นเพื่อปฏิบัติตามกฎหมาย ระงับข้อพิพาท หรือบังคับใช้ข้อตกลงของเรา",
        },
        {
          type: "p",
          text: "บันทึกการใช้งาน (log) เก็บในระยะเวลาที่สั้นกว่า เว้นแต่จำเป็นต่อการตรวจสอบความปลอดภัยหรือมีกฎหมายกำหนดให้เก็บนานกว่านั้น",
        },
      ],
    },
    {
      key: "security",
      title: "8. มาตรการรักษาความปลอดภัย",
      blocks: [
        {
          type: "p",
          text: "เราใช้มาตรการทางเทคนิคและการบริหารจัดการที่เหมาะสมเพื่อคุ้มครองข้อมูลของคุณ เช่น การเข้ารหัสข้อมูลระหว่างรับส่ง การจำกัดสิทธิ์เข้าถึงตามบทบาท และการเก็บบันทึกการเข้าใช้งาน",
        },
        {
          type: "p",
          text: "อย่างไรก็ตาม ไม่มีวิธีการรับส่งหรือจัดเก็บข้อมูลใดปลอดภัยโดยสมบูรณ์ เราจึงไม่อาจรับประกันความปลอดภัยได้อย่างเด็ดขาด หากเกิดเหตุละเมิดข้อมูลส่วนบุคคล เราจะแจ้งให้คุณและหน่วยงานที่เกี่ยวข้องทราบตามที่กฎหมายกำหนด",
        },
      ],
    },
    {
      key: "rights",
      title: "9. สิทธิของเจ้าของข้อมูลส่วนบุคคล",
      blocks: [
        { type: "p", text: "ภายใต้ PDPA คุณมีสิทธิดังต่อไปนี้" },
        {
          type: "ul",
          items: [
            "ขอเข้าถึงและขอสำเนาข้อมูลส่วนบุคคลของคุณ",
            "ขอแก้ไขข้อมูลให้ถูกต้องและเป็นปัจจุบัน",
            "ขอลบหรือทำลายข้อมูล เมื่อหมดความจำเป็นหรือคุณถอนความยินยอม",
            "ขอให้ระงับการใช้ข้อมูลชั่วคราว",
            "คัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูล",
            "ขอให้โอนย้ายข้อมูลไปยังผู้ควบคุมข้อมูลรายอื่น",
            "ถอนความยินยอมที่เคยให้ไว้ได้ตลอดเวลา โดยไม่กระทบการประมวลผลที่ทำไปแล้ว",
            "ร้องเรียนต่อคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล หากเห็นว่าเราไม่ปฏิบัติตามกฎหมาย",
          ],
        },
        {
          type: "p",
          text: `คุณใช้สิทธิได้โดยติดต่อเราตามช่องทางในข้อ 12 เราจะดำเนินการภายใน 30 วันนับแต่วันที่ได้รับคำขอ`,
        },
      ],
    },
    {
      key: "children",
      title: "10. ข้อมูลของผู้เยาว์",
      blocks: [
        {
          type: "p",
          text: "ระบบนี้จัดทำขึ้นสำหรับการใช้งานเชิงธุรกิจ ไม่ได้มุ่งให้บริการแก่ผู้ที่มีอายุต่ำกว่า 20 ปี และเราไม่มีเจตนาเก็บข้อมูลส่วนบุคคลของผู้เยาว์โดยไม่ได้รับความยินยอมจากผู้ปกครอง หากพบว่ามีการเก็บข้อมูลดังกล่าว กรุณาแจ้งเรา เพื่อดำเนินการลบออกจากระบบ",
        },
      ],
    },
    {
      key: "changes",
      title: "11. การเปลี่ยนแปลงนโยบาย",
      blocks: [
        {
          type: "p",
          text: "เราอาจปรับปรุงนโยบายฉบับนี้เป็นครั้งคราว โดยจะประกาศนโยบายฉบับใหม่บนหน้านี้พร้อมระบุวันที่ปรับปรุงล่าสุด หากเป็นการเปลี่ยนแปลงสาระสำคัญ เราจะแจ้งให้คุณทราบล่วงหน้าผ่านอีเมลหรือการแจ้งเตือนในระบบ",
        },
      ],
    },
    {
      key: "contact",
      title: "12. ติดต่อเรา",
      blocks: [
        { type: "p", text: "หากมีคำถามเกี่ยวกับนโยบายฉบับนี้ หรือต้องการใช้สิทธิของเจ้าของข้อมูล ติดต่อเราได้ที่" },
        {
          type: "ul",
          items: [
            { label: "ผู้ควบคุมข้อมูลส่วนบุคคล", text: POLICY_COMPANY.name_th },
            { label: "ที่อยู่", text: POLICY_COMPANY.address_th },
            { label: "อีเมล", text: POLICY_COMPANY.email },
            { label: "โทรศัพท์", text: POLICY_COMPANY.phone },
          ],
        },
      ],
    },
  ],
};

/* -------------------------------------------------------- เนื้อหาฉบับอังกฤษ */
const EN = {
  title: "Privacy Policy",
  subtitle: `This policy explains how ${POLICY_COMPANY.name_en} collects, uses and discloses your personal data when you use the ${POLICY_COMPANY.brand} property management system.`,
  lead: `${POLICY_COMPANY.name_en} ("the Company", "we") respects the personal data of its users and operates in accordance with the Thai Personal Data Protection Act B.E. 2562 (PDPA). This policy applies to the ${POLICY_COMPANY.brand} system — both the internal workspace for staff and agents, and the public website where visitors browse property listings.`,
  sections: [
    {
      key: "data_collect",
      title: "1. Data We Collect",
      blocks: [
        { type: "p", text: "We collect only the data necessary to provide the service:" },
        {
          type: "ul",
          items: [
            { label: "Account data", text: "Full name, nickname, email address, phone number, job title, team and profile picture." },
            { label: "Data from your LINE account", text: "If you choose to sign in with LINE (see section 2)." },
            { label: "Usage data", text: "IP address, browser type and version, pages visited, date and time of access, and sign-in records." },
            { label: "Data you enter", text: "Property records, customer and owner records, appointments, and any documents you upload." },
            { label: "Cookies", text: "Used to keep you signed in and to remember preferences such as your chosen language (see section 5)." },
          ],
        },
        {
          type: "p",
          text: "When you enter a customer's or owner's data into the system, it is your responsibility to ensure that consent has been obtained or that another lawful basis applies.",
        },
      ],
    },
    {
      key: "line",
      title: "2. Signing In With LINE",
      highlight: true,
      blocks: [
        {
          type: "p",
          text: "The system offers sign-in through LINE Login. When you press “Sign in with LINE” and grant consent on LINE's screen, we receive the following data from LINE Corporation:",
        },
        {
          type: "ul",
          items: [
            { label: "LINE User ID", text: "Used as the primary identifier that links your LINE account to your user account in our system." },
            { label: "Email address", text: "Used to match your LINE account with an existing user account, to verify that you are an authorised member of staff or agent, and to contact you about your account." },
            { label: "Display name", text: "Shown as your name in the system when no name has been set." },
            { label: "Profile picture", text: "Shown as your avatar in the system." },
          ],
        },
        {
          type: "note",
          text: "We use the email address received from LINE solely for identity verification and account linking. We do not use it for advertising, we do not sell it, and we do not disclose it to third parties for marketing purposes.",
        },
        {
          type: "p",
          text: "We request only the permissions listed above (scope: openid, profile, email). We cannot access your friends, groups, chats or messages, and we cannot send messages on your behalf.",
        },
        {
          type: "p",
          text: "If you prefer not to share your email address, you may decline it on LINE's consent screen. You can still sign in with your email address and password as usual.",
        },
        {
          type: "p",
          text: "You may unlink your LINE account at any time from the account settings page. Once unlinked, we delete the LINE user ID, display name and profile picture received from LINE from your account, and LINE sign-in will not work until you link it again.",
        },
        {
          type: "p",
          text: "Your use of LINE Login is additionally governed by LINE Corporation's own privacy policy, which is outside our control.",
        },
      ],
    },
    {
      key: "purpose",
      title: "3. How We Use Your Data",
      blocks: [
        { type: "p", text: "We use your personal data for the following purposes:" },
        {
          type: "ul",
          items: [
            "Verifying your identity, managing access rights and keeping your account secure.",
            "Providing the property, customer, appointment and reporting features relevant to your role.",
            "Contacting you about your account, in-system notifications and important service changes.",
            "Detecting, preventing and investigating unusual or unlawful activity.",
            "Analysing aggregate usage in order to improve the system.",
            "Complying with the law and with orders from competent authorities.",
          ],
        },
        {
          type: "p",
          text: "We do not use your personal data for any purpose beyond those stated, unless you give further consent or the law requires it.",
        },
      ],
    },
    {
      key: "legal_basis",
      title: "4. Legal Basis for Processing",
      blocks: [
        {
          type: "ul",
          items: [
            { label: "Performance of a contract", text: "To provide the system under the terms agreed between you or your organisation and us." },
            { label: "Legitimate interest", text: "To keep the system secure, prevent fraud and improve the service." },
            { label: "Consent", text: "For data you choose to share, such as the email address and profile from your LINE account." },
            { label: "Legal obligation", text: "Where we are required to retain or disclose data by law." },
          ],
        },
      ],
    },
    {
      key: "cookies",
      title: "5. Cookies and Similar Technologies",
      blocks: [
        {
          type: "ul",
          items: [
            { label: "Essential cookies", text: "Store your sign-in token so you do not have to sign in repeatedly. Blocking them makes the system unusable." },
            { label: "Functional cookies", text: "Remember preferences such as your chosen language and the email address you asked us to remember on the sign-in page." },
          ],
        },
        { type: "p", text: "You can configure your browser to refuse cookies, but parts of the system may then not work correctly." },
      ],
    },
    {
      key: "share",
      title: "6. Disclosure to Third Parties",
      blocks: [
        { type: "p", text: "We do not sell your personal data. We disclose it only in these cases:" },
        {
          type: "ul",
          items: [
            { label: "Service providers", text: "Such as hosting, file storage and authentication providers, bound by contract to keep the data confidential and use it only as necessary." },
            { label: "Within the organisation", text: "Other users in the company can see your data only to the extent their role permissions allow." },
            { label: "Legal requirements", text: "Under a court order or a request from a competent authority, or to protect the rights and safety of the Company and its users." },
            { label: "Business transfers", text: "In a merger or transfer of business, we will notify you before your data becomes subject to a different policy." },
          ],
        },
      ],
    },
    {
      key: "retention",
      title: "7. Data Retention",
      blocks: [
        {
          type: "p",
          text: "We keep personal data only as long as necessary for the purposes in this policy — for the lifetime of your account, and afterwards only as needed to comply with the law, resolve disputes or enforce our agreements.",
        },
        {
          type: "p",
          text: "Usage logs are kept for a shorter period, unless needed for a security investigation or required by law to be kept longer.",
        },
      ],
    },
    {
      key: "security",
      title: "8. Security Measures",
      blocks: [
        {
          type: "p",
          text: "We apply appropriate technical and organisational measures to protect your data, including encryption in transit, role-based access control and access logging.",
        },
        {
          type: "p",
          text: "No method of transmission or storage is completely secure, so we cannot guarantee absolute security. In the event of a personal data breach, we will notify you and the relevant authorities as required by law.",
        },
      ],
    },
    {
      key: "rights",
      title: "9. Your Rights",
      blocks: [
        { type: "p", text: "Under the PDPA you have the right to:" },
        {
          type: "ul",
          items: [
            "Access your personal data and request a copy of it.",
            "Have inaccurate or outdated data corrected.",
            "Have your data erased or destroyed when it is no longer needed or you withdraw consent.",
            "Request that use of your data be suspended.",
            "Object to the collection, use or disclosure of your data.",
            "Request that your data be transferred to another data controller.",
            "Withdraw consent at any time, without affecting processing already carried out.",
            "Lodge a complaint with the Personal Data Protection Committee if you believe we are not complying with the law.",
          ],
        },
        {
          type: "p",
          text: "To exercise these rights, contact us using the details in section 12. We will respond within 30 days of receiving your request.",
        },
      ],
    },
    {
      key: "children",
      title: "10. Children's Data",
      blocks: [
        {
          type: "p",
          text: "This system is intended for business use and is not directed at anyone under 20 years of age. We do not knowingly collect the personal data of minors without parental consent. If you become aware of such data in the system, please contact us so that we can remove it.",
        },
      ],
    },
    {
      key: "changes",
      title: "11. Changes to This Policy",
      blocks: [
        {
          type: "p",
          text: "We may update this policy from time to time. The revised version will be posted on this page with an updated revision date. For material changes we will notify you in advance by email or through an in-system notification.",
        },
      ],
    },
    {
      key: "contact",
      title: "12. Contact Us",
      blocks: [
        { type: "p", text: "For questions about this policy, or to exercise your rights as a data subject, contact us at:" },
        {
          type: "ul",
          items: [
            { label: "Data controller", text: POLICY_COMPANY.name_en },
            { label: "Address", text: POLICY_COMPANY.address_en },
            { label: "Email", text: POLICY_COMPANY.email },
            { label: "Phone", text: POLICY_COMPANY.phone },
          ],
        },
      ],
    },
  ],
};

export const POLICY_CONTENT = { TH, EN };
